module.exports = __webpack_public_path__ + "static/test1-2c14946e1b40fabb07e255a4376f07a4.png";